import React from "react"
import Grid from "@material-ui/core/Grid"
import { makeStyles } from "@material-ui/core/styles"
import Pagination from "@material-ui/lab/Pagination"
import { FormSpy } from "react-final-form"

const useStyles = makeStyles((theme) => ({
  pagination: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1),
  },
}))

function Paging({ onFetch, total }) {
  const classes = useStyles()

  return (
    <FormSpy subscription={{ values: true }}>
      {({ values, form: { mutators } }) => (
        <Grid
          container
          justifyContent="flex-end"
          className={classes.pagination}
        >
          <Pagination
            count={Math.ceil(total / values.limit)}
            page={values.page}
            onChange={(e, page) => {
              mutators.setPage(page)
              onFetch({
                ...values.searched,
                limit: values.limit,
                page,
              })
            }}
            color="primary"
          />
        </Grid>
      )}
    </FormSpy>
  )
}

export default Paging
